import { Stack, Typography } from '@mui/material';
import { StaticIcon } from 'web-components-ts';

export default function LogoName() {
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <StaticIcon
        name="ProductionMonitoring"
        sx={{
          color: '#8CB4C7',
          fontSize: 35
        }}
      />
      <Typography variant="h4" sx={{ color: 'white', fontWeight: 500 }}>
        Production Monitoring
      </Typography>
    </Stack>
  );
}
